import { render, staticRenderFns } from "./index-new.vue?vue&type=template&id=25fff4a6&scoped=true"
import script from "./index-new.vue?vue&type=script&lang=js"
export * from "./index-new.vue?vue&type=script&lang=js"
import style0 from "./index-new.vue?vue&type=style&index=0&id=25fff4a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fff4a6",
  null
  
)

export default component.exports